import { render, staticRenderFns } from "./period_format.vue?vue&type=template&id=5c9c68dc"
import script from "./period_format.vue?vue&type=script&lang=js"
export * from "./period_format.vue?vue&type=script&lang=js"
import style0 from "./period_format.vue?vue&type=style&index=0&id=5c9c68dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports